/*
 * Färgbyte utan omladdning (Houdini, okt 2026)
 * Byter produktsektionen på plats när kunden väljer en annan färg
 * (varje färg är en egen produkt). Hämtar den nya färgen med rätt storlek
 * redan vald från servern. Faller tillbaka på vanlig sidladdning vid fel.
 */
(function () {
  'use strict';
  if (window.__colorSwapInit) return;
  window.__colorSwapInit = true;
  if (!window.fetch || !window.DOMParser || !window.history || !window.history.pushState) return;

  var DEBUG = /[?&]cs_debug=1/.test(window.location.search); // felsökning: lägg till ?cs_debug=1 i adressen
  function toast(msg) {
    if (!DEBUG) return;
    var t = document.getElementById('cs-debug');
    if (!t) {
      t = document.createElement('div');
      t.id = 'cs-debug';
      t.style.cssText = 'position:fixed;left:8px;bottom:8px;z-index:99999;background:#000;color:#fff;font:12px/1.3 Arial,sans-serif;padding:6px 8px;border-radius:4px;opacity:.85;pointer-events:none;max-width:90vw';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    clearTimeout(t._h); t._h = setTimeout(function () { t.remove(); }, 7000);
  }

  var productCache = {};
  var sectionCache = {}; // cache för hela sidor per färg och storlek
  var BREADCRUMB_ID = 'breadcrumbs-nav'; // ligger i <main> och följer med automatiskt

  function sectionOf(el) { return el && el.closest ? el.closest('.shopify-section') : null; }
  function sectionId(sec) { return sec && sec.id ? sec.id.replace(/^shopify-section-/, '') : null; }
  function cleanUrl(href) { var u = new URL(href, window.location.origin); return u.origin + u.pathname; }

  function sizeRadios(root) {
    return Array.prototype.slice.call(root.querySelectorAll('input[type="radio"]')).filter(function (i) {
      return !i.closest('.product__metafield-variants');
    });
  }
  function selectedSize(sec) {
    var r = sizeRadios(sec).filter(function (i) { return i.checked; })[0];
    return r ? r.value : null;
  }

  // Produktens varianter (liten JSON) för att hitta rätt variant-ID för vald storlek
  function productJson(href) {
    var key = cleanUrl(href);
    if (!productCache[key]) {
      productCache[key] = fetch(key + '.js', { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('Produktdata HTTP ' + r.status);
        return r.json();
      });
      productCache[key].catch(function () { delete productCache[key]; });
    }
    return productCache[key];
  }

  function variantFor(product, size) {
    if (!size || !product || !product.variants) return null;
    var match = product.variants.filter(function (v) { return (v.options || []).indexOf(size) > -1; })[0];
    return match ? match.id : null;
  }

  // Hämtar hela sidan för den nya färgen med rätt variant vald (samma som temats eget produktbyte)
  function load(href, id, size) {
    var key = cleanUrl(href) + '|' + (size || '');
    if (!sectionCache[key]) {
      sectionCache[key] = productJson(href).then(function (product) {
        var u = new URL(cleanUrl(href));
        var vid = variantFor(product, size);
        if (vid) u.searchParams.set('variant', vid);
        return fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('Sida HTTP ' + r.status);
          return r.text();
        }).then(function (html) { return { html: html, variant: vid }; });
      });
      sectionCache[key].catch(function () { delete sectionCache[key]; });
    }
    return sectionCache[key];
  }

  // Bevaka-produkten-formulärets obligatoriska e-postfält kan efter bytet räknas till köpformuläret
  // och blockera "Lägg i varukorgen". Dolda obligatoriska fält i köpformuläret görs därför valfria.
  function isCartForm(f) { return f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') > -1; }
  function relaxForm(f) {
    if (!isCartForm(f)) return;
    f.noValidate = true;
    Array.prototype.slice.call(f.elements || []).forEach(function (el) {
      if (el.required && (el.offsetParent === null || el.name === 'email' || el.hasAttribute('data-notification-email'))) {
        el.required = false;
        el.removeAttribute('required');
      }
    });
  }
  function fixCartForms(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('form')).forEach(relaxForm);
  }
  // Körs precis innan temat kontrollerar formuläret (klick på köpknappen eller submit)
  window.addEventListener('click', function (e) {
    if (!window.__colorSwapped) return;
    var btn = e.target && e.target.closest ? e.target.closest('button, input[type="submit"]') : null;
    if (btn && btn.form) relaxForm(btn.form);
  }, true);
  window.addEventListener('submit', function (e) { if (window.__colorSwapped) relaxForm(e.target); }, true);

  // Spårning: ett färgbyte räknas som en produktvisning (ingen ny sidladdning sker)
  function track(href, variantId) {
    productJson(href).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.id === variantId; })[0] || (p.variants || [])[0] || {};
      var price = (v.price || p.price || 0) / 100;
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
      var item = { item_id: v.sku || String(v.id || p.id), item_name: p.title, item_variant: v.title, price: price };
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('color_swap_product_viewed', { productId: p.id, variantId: v.id, title: p.title, url: window.location.href, price: price, currency: currency }); } catch (e) {}
      // Eget händelsenamn för att inte dubbelräkna befintliga view_item-taggar. Kan kopplas till GA4 i GTM vid behov.
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'color_swap_view_item', ecommerce: { currency: currency, value: price, items: [item] } }); } catch (e) {}
      try { if (typeof window.fbq === 'function') window.fbq('track', 'ViewContent', { content_ids: [String(v.id || p.id)], content_type: 'product', content_name: p.title, value: price, currency: currency }); } catch (e) {}
      try { if (window.Shopify && Shopify.Products && Shopify.Products.recordRecentlyViewed) Shopify.Products.recordRecentlyViewed({ handle: p.handle }); } catch (e) {}
    }).catch(function () {});
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function swap(link) {
    var sec = sectionOf(link);
    var id = sectionId(sec);
    if (!id) return false;
    var href = link.href;
    var size = selectedSize(sec);
    var t0 = Date.now();
    sec.style.transition = 'opacity .15s';
    sec.style.opacity = '0.5';

    load(href, id, size).then(function (res) {
      var doc = parse(res.html);
      var oldMain = document.querySelector('main');
      var newMain = doc.querySelector('main');
      if (!(window.HTMLUpdateUtility && HTMLUpdateUtility.viewTransition && oldMain && newMain && newMain.querySelector('product-info'))) {
        throw new Error('Temats bytesfunktion saknas');
      }
      // Exakt samma byte som temat gör när det själv byter produkt (product-info.js, handleSwapProduct)
      HTMLUpdateUtility.viewTransition(oldMain, newMain, [], [function (node) {
        fixCartForms(node || document);
        if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) Shopify.PaymentButton.init();
        if (window.ProductModel && ProductModel.loadShopifyXR) ProductModel.loadShopifyXR();
      }]);
      var newTitle = doc.querySelector('head title');
      if (newTitle) document.title = newTitle.textContent;
      var url = cleanUrl(href) + (res.variant ? '?variant=' + res.variant : '');
      history.pushState({ colorSwap: true }, '', url);
      window.__colorSwapped = true;
      document.dispatchEvent(new CustomEvent('houdini:color-swapped', { detail: { url: url, variant: res.variant } }));
      track(href, res.variant);

      fixCartForms(document);
      setTimeout(function () {
        fixCartForms(document);
        var idInput = document.querySelector('main form[action*="/cart/add"] input[name="id"]');
        toast('Färgbyte OK: ' + (Date.now() - t0) + ' ms · storlek ' + (size || '–') + ' · variant ' + (idInput ? (idInput.value || 'TOM') : 'saknas'));
      }, 300);
      prefetchSiblings();
    }).catch(function (err) {
      toast('Fallback: ' + (err && err.message ? err.message : 'fel'));
      setTimeout(function () { window.location.href = href; }, DEBUG ? 900 : 0);
    });
    return true;
  }

  function linkFrom(e) {
    var a = e.target && e.target.closest ? e.target.closest('a.sibling__link') : null;
    if (!a || a.classList.contains('sibling__link--current')) return null;
    return a;
  }

  window.addEventListener('click', function (e) {
    var a = linkFrom(e);
    if (!a) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (swap(a)) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function warm(e) {
    var a = linkFrom(e);
    if (!a) return;
    var sec = sectionOf(a);
    var id = sectionId(sec);
    if (id) load(a.href, id, selectedSize(sec));
  }
  document.addEventListener('pointerdown', warm, { passive: true });
  document.addEventListener('touchstart', warm, { passive: true });
  document.addEventListener('mouseover', warm, { passive: true });

  // Förladda övriga färger i bakgrunden (med nu vald storlek)
  function prefetchSiblings() {
    var links = Array.prototype.slice.call(document.querySelectorAll('a.sibling__link:not(.sibling__link--current)'), 0, 8);
    var run = function () {
      links.forEach(function (a, i) {
        setTimeout(function () {
          var sec = sectionOf(a);
          var id = sectionId(sec);
          if (id) load(a.href, id, selectedSize(sec));
        }, i * 300);
      });
    };
    if (window.requestIdleCallback) requestIdleCallback(run, { timeout: 3000 }); else setTimeout(run, 1500);
  }
  if (document.readyState === 'complete') prefetchSiblings();
  else window.addEventListener('load', prefetchSiblings);
  // När kunden väljer storlek: förladda färgerna igen med den storleken
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio' && !e.target.closest('.product__metafield-variants')) prefetchSiblings();
  });

  // Debug: visa vad som händer när kunden trycker på köpknappen
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') > -1) {
      var i = f.querySelector('input[name="id"]');
      toast('Lägg i varukorg: variant ' + (i ? (i.value || 'TOM') : 'saknas'));
    }
  }, true);

  window.addEventListener('popstate', function () { window.location.reload(); });
  toast('Färgbyte-skript laddat (v7)');
})();